import { render, staticRenderFns } from "./librosObsequios.vue?vue&type=template&id=4e331692&scoped=true"
import script from "./librosObsequios.vue?vue&type=script&lang=js"
export * from "./librosObsequios.vue?vue&type=script&lang=js"
import style0 from "./librosObsequios.vue?vue&type=style&index=0&id=4e331692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e331692",
  null
  
)

export default component.exports